import {Component, Input, OnChanges} from '@angular/core';
import {SuperObjectModel} from '../../core/definitions/super-object-model';
import {SearchObject} from '../../core/definitions/search-object';
import {RefData, RefParams, RefService} from '../../core/ref.service';
import {PrimusRouterService} from '../../core/primus-router.service';

@Component({
  selector: 'app-recto-verso-buttons',
  templateUrl: './recto-verso-buttons.component.html',
  styleUrls: ['./recto-verso-buttons.component.scss']
})
export class RectoVersoButtonsComponent implements OnChanges {
  @Input() object: SuperObjectModel;

  rectoObject: SuperObjectModel = null;
  versoObject: SuperObjectModel = null;
  isRecto = false;
  isVerso = false;
  hasRectoVerso = false;

  constructor(private readonly primusRouter: PrimusRouterService,
              private readonly ref: RefService) {
  }

  ngOnChanges(): void {
    this.hasRectoVerso =
      (this.object.recto_verso && !!this.object.recto_verso.relation_id) ||
      (this.object.verso_recto && !!this.object.verso_recto.context_id);
    this.versoObject = new SuperObjectModel();
    this.rectoObject = new SuperObjectModel();
    if (this.object.recto_verso && this.object.recto_verso.relation_id) {
      this.versoObject.artifact_id = this.object.recto_verso.relation_id;
      this.isRecto = true;
    } else {
      this.versoObject.artifact_id = this.object.artifact_id;
    }
    if (this.object.verso_recto && this.object.verso_recto.context_id) {
      this.rectoObject.artifact_id = this.object.verso_recto.context_id;
      this.isVerso = true;
    } else {
      this.rectoObject.artifact_id = this.object.artifact_id;
    }
  }
  async goToSearchItem(item) {
    if (item) {
      const refInfo = await this.createRef(item);
      await this.primusRouter.navigateState(refInfo.stateName, refInfo.param, {reload: true});
    }
  }

  private async createRef(searchItem: SearchObject): Promise<RefData> {
    const params = new RefParams(searchItem);
    params.searchItemIndex = null;
    params.rootObjId = null;
    params.rootObjType = null;
    params.stateParams = {
      listName: 'overview'
    };
    return await this.ref.makeRef(params);
  }
}
